import { makeAutoObservable, runInAction } from 'mobx'
import DriverService from '../services/DriverService'
import responseStatusStore from '../../lib/stores/ResponseStatusStore'
const responseStatus = new responseStatusStore()

class LicenseStore {
  constructor () {
    this.license = null
    this.isLoading = false
    this.serverError = ''
    this.operationId = null

    makeAutoObservable(this)

    this.driverService = new DriverService()
  }

  get selectedCitationsIds () {
    return this.license.citations
      .filter((citation) => citation.selected)
      .map((citation) => citation.id)
  }

  setOperationId (operationId) {
    runInAction(() => {
      this.operationId = operationId
    })
  }

  setLicense (license) {
    runInAction(() => {
      this.license = license
    })
  }

  clearServerError () {
    this.serverError = ''
  }

  toggleCitation (citationId) {
    const index = this.license.citations.findIndex((citation) => citation.id == citationId)
    this.license.citations[index].selected = !this.license.citations[index].selected
    runInAction(() => {
      this.license = this.license.shallowClone()
    })
  }

  async proceedToCheckout () {
    this.isLoading = true
    this.serverError = null

    try {
      const { bill } = await this.driverService.caselessBill(
        this.operationId,
        this.license.number,
        this.license.state,
        this.selectedCitationsIds
      )
      this.license.bill = bill
      runInAction(() => {
        this.license = this.license.shallowClone()
        this.isLoading = false
      })
      return true
    } catch (error) {
      console.log(error)
      // TODO: Handle error :)
      runInAction(() => {
        this.isLoading = false
      })
      return false
    }
  }

  async loadCaselessByLicense (licenseNumber, licenseState, operationId) {
    this.isLoading = true
    this.serverError = null

    try {
      const license = await this.driverService.caselessSearch(
        operationId,
        licenseNumber,
        licenseState
      )

      runInAction(() => {
        this.license = license
        this.isLoading = false
      })
    } catch (e) {
      runInAction(() => {
        if (e?.response?.status === 404) {
          this.serverError = 'No results were found. Please confirm your information is correct and resubmit.'
        } else if (e?.response?.status === 422) {
          // responseStatus.setApplicationError(e?.response?.data?.message)
          this.serverError = e?.response?.data?.message
        } else {
          responseStatus.setError500()
        }

        this.isLoading = false
      })
    }
  }
}

export default LicenseStore
